'use client';

import { Skeleton } from '@/components/ui/feedback/status/skeleton';

export function WorkspaceConversationSkeleton({
  count = 2,
  label,
}: {
  count?: number;
  label?: string;
}) {
  return (
    <div
      className="cms-block-workspace-workspace-1-workspace-conversation__skeleton"
      aria-busy="true"
      data-workspace-conversation-skeleton
    >
      {label ? (
        <output className="sr-only" aria-live="polite">
          {label}
        </output>
      ) : null}
      <div aria-hidden="true">
        {Array.from({ length: count }, (_, index) => (
          <div
            key={index}
            className="cms-block-workspace-workspace-1-workspace-conversation__skeletonTurn"
          >
            <Skeleton className="cms-block-workspace-workspace-1-workspace-conversation__skeletonAvatar rounded-pill" />
            <div className="cms-block-workspace-workspace-1-workspace-conversation__skeletonMessage">
              <Skeleton className="cms-block-workspace-workspace-1-workspace-conversation__skeletonLine cms-block-workspace-workspace-1-workspace-conversation__skeletonLineLong" />
              <Skeleton className="cms-block-workspace-workspace-1-workspace-conversation__skeletonLine cms-block-workspace-workspace-1-workspace-conversation__skeletonLineShort" />
            </div>
            <Skeleton className="cms-block-workspace-workspace-1-workspace-conversation__skeletonAvatar" />
            <div className="cms-block-workspace-workspace-1-workspace-conversation__skeletonResponse">
              <div className="cms-block-workspace-workspace-1-workspace-conversation__skeletonHeader">
                <Skeleton className="cms-block-workspace-workspace-1-workspace-conversation__skeletonLine cms-block-workspace-workspace-1-workspace-conversation__skeletonModel" />
                <Skeleton className="cms-block-workspace-workspace-1-workspace-conversation__skeletonLine cms-block-workspace-workspace-1-workspace-conversation__skeletonTime" />
              </div>
              <Skeleton className="cms-block-workspace-workspace-1-workspace-conversation__skeletonResult" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function WorkspaceConversationLoading({ label }: { label?: string }) {
  return (
    <section
      className="cms-block-workspace-workspace-1-workspace-conversation"
      aria-busy="true"
      data-workspace-conversation
      data-workspace-conversation-loading
    >
      <div className="cms-block-workspace-workspace-1-workspace-conversation__scroll">
        <WorkspaceConversationSkeleton label={label} />
      </div>
    </section>
  );
}
